module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAG1BMVEUAAABUQz5UQj1bSUBVQz1UQj3s6un///+EeHQEv5+TAAAABXRSTlMA5qYc7dRG+h8AAABWSURBVEjHYxgF9AbMiqEEgJABg0koQeDMoEpYURCDKGFFgQwgEo+TwfKjikYVDWtFbRlEKEovo1QRwrrBFwSjikYVUVkRURUQUVUZUZUicdXrKKAzAAARqdI/Ns/AiwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download/download_icon_pad_selected.png
// module id = 3Pov
// module chunks = 10